import Flickity from 'flickity';
import { sleep } from '../lib/utils.js';

export function openProductGalleryAt(slide: number): void {
  const modal = document.querySelector('.js-productGalleryModal')
  if (modal instanceof FFProductGalleryModal) {
    void modal.openAt(slide)
  }
}

export class FFProductGalleryModal extends HTMLDialogElement {
	scrollEnabled = false
  flkty?: Flickity
	index = '0'

  DOM: {
    close: HTMLElement | null
    rotator: HTMLElement | null
  }

	constructor(){
    super()
    this.DOM = {
			close: this.querySelector('.close'),
			rotator: this.querySelector(".rotator"),
		}
    this.initRotator();
    this.modalEvents();
	}

	modalEvents(){
		this.DOM.close?.addEventListener('click', this.galleryClose.bind(this));
	}

	initRotator(){
    if( !this.DOM.rotator ) return
    this.flkty = new Flickity( this.DOM.rotator, {
			autoPlay: false,
			pageDots: true,
			prevNextButtons: true,
			wrapAround: false,
		});
	}

	async openAt( slide: number ){
    this.showModal()
    await sleep(10)
    this.flkty?.resize()
    this.flkty?.select( slide, false, true )
    this.style.opacity = "1"
	}

	async galleryClose(){
    this.style.opacity = "0"
    await sleep(300)
    this.close()
	}
};
customElements.define('ff-product-gallery-modal', FFProductGalleryModal, { extends: 'dialog' });